import { useEffect, useState } from 'react';
import { useDeleteProject } from 'reactQuery/mutations';
import { useDoctorProfile, useProductDetails } from 'reactQuery/queries';

export const useDesignHuddleProjectList = () => {
  const [showDownloadAgreementModal, setShowDownloadAgreementModal] =
    useState(false);
  const [downloadProjectId, setDownloadProjectId] = useState('');
  const [activeProjectId, setActiveProjectId] = useState('');
  const [activeSKU, setActiveSKU] = useState('');
  const [showCustomizationModal, setShowCustomizationModal] = useState(false);
  const { data: doctorProfile } = useDoctorProfile();

  const deleteProjectMutation = useDeleteProject(doctorProfile?.userName, true);

  const deleteProject = (projectId: string) => {
    deleteProjectMutation.mutate({
      projectId: projectId,
      showNotification: false,
    });
  };

  const { data: product, refetch } = useProductDetails(activeSKU);

  useEffect(() => {
    refetch();
  }, [activeSKU]);

  const onSelectProject = (projectId: string, sku: string) => {
    setActiveProjectId(projectId);
    setActiveSKU(sku);
    setShowCustomizationModal(true);
  };

  const onCloseEditor = () => {
    setActiveProjectId('');
    setShowCustomizationModal(false);
  };

  const onCloseDownloadAgreementModal = () => {
    setShowDownloadAgreementModal(false);
  };

  return {
    deleteProject,
    onSelectProject,
    onCloseEditor,
    onCloseDownloadAgreementModal,
    showDownloadAgreementModal,
    setShowDownloadAgreementModal,
    downloadProjectId,
    setDownloadProjectId,
    activeProjectId,
    setActiveProjectId,
    activeSKU,
    setActiveSKU,
    product,
    showCustomizationModal,
    setShowCustomizationModal,
    deleteProjectMutation,
  };
};
